export const LIBRARIES = {
  GOOGLE_MAPS: 'google-maps',
  GOOGLE_ANALYTICS: 'google-analytics',
};

const LIBRARIES_TYPES = Object.values(LIBRARIES);

const LIBRARIES_CONFIGS = {
  [LIBRARIES.GOOGLE_MAPS]: {
    url: API_KEY => `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&language=en&region=US`,
    lib: () => window.google,
  },
  [LIBRARIES.GOOGLE_ANALYTICS]: {
    url: () => 'https://www.google-analytics.com/analytics.js',
    lib: () => {},
  },
};

export function isLibraryLoaded(libraryType) {
  return !!document.querySelector(`#${libraryType}`);
}

export function loadLibrary(libraryType, ...params) {
  if (!LIBRARIES_TYPES.includes(libraryType)) {
    throw new Error(`You must pass correct library type. Valid types: ${LIBRARIES_TYPES.join(', ')}`);
  }

  return new Promise((resolve, reject) => {
    const config = LIBRARIES_CONFIGS[libraryType];

    if (isLibraryLoaded(libraryType)) {
      resolve(config.lib());
      return undefined;
    }

    const script = document.createElement('script');

    script.id = libraryType;
    script.onload = () => resolve(config.lib());
    script.onerror = reject;
    document.body.appendChild(script);
    script.src = config.url(...params);

    return undefined;
  });
}
